
import { Paper } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useMemo } from "react";

const useStyles = makeStyles({
  root: {
    border: 0,
    color: 'text.primary',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent'
  },
  tableHeading: {
    marginLeft: 10,
    marginTop: 10,
  },
  table: {
    overflow: 'auto',
    marginTop: 0,
    marginBottom: 0,
    border: 'none'
  },
});

export const RTFOSeismicityDataTable = ({ currentRTFO, seismicData, darkMode }) => {
  
    // STYLES
    const classes = useStyles();

    const rows = useMemo(() => {
      if (!seismicData || seismicData?.length === 0) return [];

      return seismicData?.map(event => {
        return {
          id: event?.id,
          date: new Date(event?.time)?.toLocaleString(),
          type: event?.type === 'm' ? 'Confirmed' : event?.type === 'a' ? 'Realtime' : event?.type === 'd' ? 'High Precision' : '',
          distance: parseFloat(event?.distance?.toFixed(2)),
          stageName: event?.stageName,
          magnitude: event?.magnitude,
          momentMagnitude: event?.momentMagnitude,
          localMagnitude: event?.localMagnitude,
          padUwi: event?.padUwi,
          stageNumber: event?.stageNumber,
          wellName: event?.wellName,
          wellUwi: event?.wellUwi || currentRTFO?.stageData?.[event?.stageName]?.wellUwi || event?.stageName?.split('_')?.[1] || '',
          wellLicense: event?.wellLicense,
          cumProppant: Number((event?.cumProppant || 0)?.toFixed(2)),
          plannedProppant: Number((event?.plannedProppant || 0)?.toFixed(2)),
          stageTime: Number((event?.stageTime || 0)?.toFixed(2)),
          rate: Number((event?.rate || 0)?.toFixed(2)),
          averageRate: Number((event?.averageRate || 0)?.toFixed(2)),
          rate10Min: Number((event?.rate10Min || 0)?.toFixed(2)),
          pressure: Number((event?.pressure || 0)?.toFixed(2)),
          cleanVolume: Number((event?.cleanVolume || 0)?.toFixed(2)),
          slurryVolume: Number((event?.slurryVolume || 0)?.toFixed(2)),
          previousWellUwi: event?.previousWellUwi,
          previousStageNumber: event?.previousStageNumber,
          previousStageName: event?.previousStageName,
          previousStageEndTimestamp: new Date(event?.previousStageEndTimestamp)?.toLocaleString(),
          wireline1Depth: Number((event?.wirelineData?.['Wireline 1']?.depth)?.toFixed(2)) || null,
          wireline1Speed: Number((event?.wirelineData?.['Wireline 1']?.speed)?.toFixed(2)) || null,
          wireline1Rate: Number((event?.wirelineData?.['Wireline 1']?.rate)?.toFixed(2)) || null,
          wireline1Status: event?.wirelineData?.['Wireline 1']?.status?.toUpperCase() || 'Unknown',
          wireline2Depth: Number((event?.wirelineData?.['Wireline 2']?.depth)?.toFixed(2)) || null,
          wireline2Speed: Number((event?.wirelineData?.['Wireline 2']?.speed)?.toFixed(2)) || null,
          wireline2Rate: Number((event?.wirelineData?.['Wireline 2']?.rate)?.toFixed(2)) || null,
          wireline2Status: event?.wirelineData?.['Wireline 2']?.status?.toUpperCase() || 'Unknown'
        };
      })

      // return seismicData?.map(event => {

      //   const stageData = currentRTFO?.stageData?.[event?.activeStageName]?.coldboreData;

      //   // Calculate slurry volume
      //   const slurryVolumeArray = [];
      //   stageData?.forEach((d, i) => {
      //     const slurryVolume = (((d?.rate || 0) * (i === 0 ? d?.time : (d?.time - stageData?.[i-1]?.time)))) || 0;
      //     slurryVolumeArray.push({
      //       timestamp: d.timestamp,
      //       slurryVolume: i === 0 ? slurryVolume : ((slurryVolumeArray?.[i-1]?.slurryVolume || 0) + slurryVolume)
      //     });
      //   });

      //   // Calculate cum. proppant
      //   const cumProppantArray = [];
      //   stageData?.forEach((d, i) => {
      //     const proppantMass = (((d?.clean || 0) * (i === 0 ? d?.time : (d?.time - stageData?.[i-1]?.time))) * (d?.proppant || 0) / 1000) || 0;
      //     cumProppantArray.push({
      //       timestamp: d.timestamp,
      //       cumProppant: i === 0 ? proppantMass : ((cumProppantArray?.[i-1]?.cumProppant || 0) + proppantMass)
      //     });
      //   });


      //   const eventTimestamp = new Date(event?.time)?.getTime();

        
      //   const eventStageData = stageData?.find(d => d.timestamp >= eventTimestamp);
        
      //   const cumProppant = ((cumProppantArray?.find(d => d.timestamp >= eventTimestamp)?.cumProppant - cumProppantArray?.[0]?.cumProppant) || cumProppantArray?.[cumProppantArray?.length - 1]?.cumProppant)?.toFixed(2);
      //   const slurryVolume = ((slurryVolumeArray?.find(d => d.timestamp >= eventTimestamp)?.slurryVolume - slurryVolumeArray?.[0]?.slurryVolume) || slurryVolumeArray?.[slurryVolumeArray?.length - 1]?.slurryVolume)?.toFixed(2);
      //   const cleanVolume = ((eventStageData?.cleanVolume - stageData?.[0]?.cleanVolume) || stageData?.[stageData?.length - 1]?.cleanVolume)?.toFixed(2);
      //   const eventPressure = (eventStageData?.pressure || stageData?.[stageData?.length - 1]?.pressure)?.toFixed(2);
      //   const eventRate = (eventStageData?.rate || stageData?.[stageData?.length - 1]?.rate)?.toFixed(2);


      //   return {
      //     id: event?.id,
      //     date: new Date(event?.time)?.toLocaleString(),
      //     type: event?.type === 'm' ? 'Confirmed' : 'Realtime',
      //     distance: parseFloat(event?.distance?.toFixed(2)),
      //     activeStage: event?.activeStageName,
      //     magnitude: event?.magnitude,
      //     momentMagnitude: event?.momentMagnitude,
      //     localMagnitude: event?.localMagnitude,
      //     eventPressure,
      //     eventRate,
      //     slurryVolume,
      //     cleanVolume,
      //     cumProppant
      //   };
      // });
    }, [currentRTFO?.stageData, seismicData]);
  
  try {

    const columns = [
      {
        field: 'id',
        headerName: 'Event ID',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        type: 'string'
      },
      {
        field: 'date',
        headerName: 'Date',
        width: 200,
        editable: false,
        sortable: true,
        filterable: true,
        type: 'string'
      },
      {
        field: 'stageName',
        headerName: 'Active Stage',
        width: 150,
        editable: false,
        sortable: true,
        filterable: true,
        type: 'string'
      },
      {
        field: 'stageNumber',
        headerName: 'Stage No.',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        type: 'string'
      },
      {
        field: 'wellUwi',
        headerName: 'Well UWI',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        type: 'string'
      },
      {
        field: 'type',
        headerName: 'Event Type',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        type: 'string'
      },
      {
        field: 'magnitude',
        headerName: 'Magnitude',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true
      },
      {
        field: 'momentMagnitude',
        headerName: 'Moment Magnitude',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true
      },
      {
        field: 'localMagnitude',
        headerName: 'Local Magnitude',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true
      },
      {
        field: 'distance',
        headerName: 'Distance (km)',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true
      },
      {
        field: 'stageTime',
        headerName: 'Stage Time (min)',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true
      },
      {
        field: 'pressure',
        headerName: 'Pressure (MPa)',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true
      },
      {
        field: 'rate',
        headerName: 'Rate (m3/min)',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true
      },
      {
        field: 'averageRate',
        headerName: 'Average Rate (m3/min)',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true
      },
      {
        field: 'rate10Min',
        headerName: '10 Min. Rate (m3/min)',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true
      },
      {
        field: 'cleanVolume',
        headerName: 'Clean Volume (m3)',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true
      },
      {
        field: 'slurryVolume',
        headerName: 'Slurry Volume (m3)',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true
      },
      {
        field: 'cumProppant',
        headerName: 'Cum. Proppant (ton)',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true
      },
      {
        field: 'plannedProppant',
        headerName: 'Planned Proppant (ton)',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true
      },
      {
        field: 'previousStageName',
        headerName: 'Prev. Stage',
        width: 150,
        editable: false,
        sortable: true,
        filterable: true,
        type: 'string'
      },
      {
        field: 'previousStageNumber',
        headerName: 'Prev. Stage No.',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        type: 'string'
      },
      {
        field: 'previousStageEndTimestamp',
        headerName: 'Prev. Stage End',
        width: 200,
        editable: false,
        sortable: true,
        filterable: true,
        type: 'string'
      },
      {
        field: 'wireline1Depth',
        headerName: 'WL 1 Depth (m)',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true
      },
      {
        field: 'wireline1Speed',
        headerName: 'WL 1 Speed (m/min)',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true
      },
      {
        field: 'wireline1Rate',
        headerName: 'WL 1 Rate (m3/min)',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true
      },
      {
        field: 'wireline1Status',
        headerName: 'WL 1 Status',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        type: 'string'
      },
      {
        field: 'wireline2Depth',
        headerName: 'WL 2 Depth (m)',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true
      },
      {
        field: 'wireline2Speed',
        headerName: 'WL 2 Speed (m/min)',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true
      },
      {
        field: 'wireline2Rate',
        headerName: 'WL 2 Rate (m3/min)',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true
      },
      {
        field: 'wireline2Status',
        headerName: 'WL 2 Status',
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        type: 'string'
      }
    ];

    return (
      <Paper className={classes.root} elevation={0}>
        <DataGrid
          // loading={currentRTFO?.isLoadingData}
          rows={rows}
          columns={columns}
          rowsPerPageOptions={[10,25,50,100]}
          disableSelectionOnClick
          className={classes.table}
          components={{
            Toolbar: GridToolbar,
          }}
          sx={{
            '& .MuiDataGrid-row:nth-of-type(odd)': {
              backgroundColor: darkMode ? 'grey' : 'whitesmoke'
            },
          }}
          density="compact"
          style={{fontSize: '12px'}}
        />
      </Paper>
    );
  } catch (error) {
    return <></>
  };
};

